import { usePathname } from "next/navigation";
import React from "react";
import NavListItem from "./NavListItem";

const NavigationBar = ({
	navigationList,
	setShowMainDropdown,
	ctaUrl = "",
}) => {
	const pathname = usePathname();

	return navigationList?.map((navInfo) => {
		const activeStyle = navInfo.link === pathname;

		return (
			<NavListItem
				ctaUrl={ctaUrl}
				key={navInfo.order}
				navInfo={navInfo}
				setShowMainDropdown={setShowMainDropdown}
				activeStyle={activeStyle}
			/>
		);
	});
};

export default NavigationBar;
